import React from 'react';

import classNames from 'classnames';

import { ENavbarTypes } from '../../../../../../types/working-model';
import { replaceSpaceWithUnderscore } from '../../../../../../utils/utils';

const NAVBAR_POSITIONS_LIST = [ENavbarTypes.Horizontal, ENavbarTypes.Vertical];

interface IEventHeaderModalContentProps {
	navPosition: ENavbarTypes | undefined;
	setNavPosition: (position: ENavbarTypes) => void;
}

export default function EventHeaderModalContent({ navPosition, setNavPosition }: IEventHeaderModalContentProps): JSX.Element {
	return (
		<div className="nav-position-items">
			{NAVBAR_POSITIONS_LIST.map((position, index) => {
				const key = `${replaceSpaceWithUnderscore(position)}-${index}`;
				const currentPosition = navPosition || ENavbarTypes.Vertical;
				const buttonText = position === ENavbarTypes.Vertical ? 'Side nav' : 'Top nav';
				const handleSetNavPosition = () => setNavPosition(position);

				return (
					<button
						key={key}
						onClick={handleSetNavPosition}
						className={classNames('clear no-style', { selected: currentPosition === position })}
					>
						<span
							className={classNames(
								{
									'side-nav-position': position === ENavbarTypes.Vertical,
									'top-nav-position': position === ENavbarTypes.Horizontal,
								}
							)}
						>
						</span>
						{buttonText}
					</button>
				);
			})}
		</div>
	);
}
